
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from '@/store'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import VueSweetAlert from 'vue-sweetalert2'
import VueTheMask from 'vue-the-mask'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import 'viewerjs/dist/viewer.css'
import esMessage from 'devextreme/localization/messages/es.json'
import 'devextreme-intl'
import { locale, loadMessages } from 'devextreme/localization'

loadMessages(esMessage)
locale('es')

Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.use(VueMomentJS, moment)
Vue.use(VueSweetAlert)

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.conditionalRoute)) {
    if (store.state.token === '') {
      next({path: '/login'})
    } else {
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  created: function () {
    this.$moment.locale('es')
  },
  store,
  moment
})



// WEBPACK FOOTER //
// ./src/main.js